
export default function About() {
  return (
    <section id="about" className="py-16 sm:py-20 bg-gradient-to-b from-[#0A1628] to-[#0D1F3C] relative overflow-hidden">
      <div className="absolute inset-0 opacity-10 pointer-events-none">
        <div className="absolute top-20 left-10 w-48 h-48 bg-[#FFD700] rounded-full filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-64 h-64 bg-[#FFD700] rounded-full filter blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="order-2 md:order-1">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-5">
              About <span className="text-[#FFD700]">Beyond Electrical</span>
            </h2>
            <div className="space-y-4 text-gray-300 text-sm sm:text-base leading-relaxed">
              <p>
                At Beyond Electrical we like to go above and beyond the stereotypical trades-person image. We deeply value our customers and go the extra mile to get the job done.
              </p>
              <p>
                We are <strong className="text-[#FFD700]">NICEIC approved contractors</strong> and carry out all work inline with BS7671 Regulations with appropriate certification.
              </p>
              <p>
                We provide a wide range of electrical services from electrical fault finding to completely tailored designed installations.
              </p>
            </div>
            <div className="mt-6 grid grid-cols-2 gap-4">
              <div className="bg-white/5 backdrop-blur-sm p-4 rounded-lg border border-[#FFD700]/20 hover:border-[#FFD700] transition-all duration-300">
                <div className="text-3xl font-bold text-[#FFD700] mb-1">15+</div>
                <div className="text-sm text-gray-400">Years Experience</div>
              </div>
              <div className="bg-white/5 backdrop-blur-sm p-4 rounded-lg border border-[#FFD700]/20 hover:border-[#FFD700] transition-all duration-300">
                <div className="text-3xl font-bold text-[#FFD700] mb-1">100%</div>
                <div className="text-sm text-gray-400">Certified</div>
              </div>
            </div>
          </div>

          <div className="order-1 md:order-2">
            <div className="relative">
              <div className="absolute inset-0 bg-[#FFD700] rounded-lg transform rotate-2 opacity-20"></div>
              <img
                src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/9111e8013d5a0a3cfa99a8403119dbac.png"
                alt="Electrician in Rickmansworth"
                className="relative rounded-lg shadow-2xl w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>

        {/* NICEIC 10-Year Certification Banner */}
        <div className="mt-12 sm:mt-16 bg-white/5 backdrop-blur-sm border border-[#FFD700]/30 rounded-2xl p-6 sm:p-10 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-shrink-0 flex justify-center">
            <img
              src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/9bbf3e6588e0edccc72cd2106c28ef83.jpeg"
              alt="NICEIC Approved Contractor - Celebrating Over 10 Years Certification"
              className="h-36 sm:h-44 w-auto object-contain drop-shadow-xl"
            />
          </div>
          <div className="flex-1 text-center md:text-left">
            <div className="inline-flex items-center gap-2 bg-[#FFD700]/20 border border-[#FFD700]/50 text-[#FFD700] px-3 py-1 rounded-full text-xs font-semibold mb-3">
              <i className="ri-award-fill"></i>
              <span>Proud Achievement</span>
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3">
              Over <span className="text-[#FFD700]">10 Years</span> as a NICEIC Approved Contractor
            </h3>
            <p className="text-gray-300 text-sm sm:text-base leading-relaxed max-w-xl">
              We are proud to have maintained our <strong className="text-[#FFD700]">NICEIC Approved Contractor</strong> status for over a decade. This milestone reflects our unwavering commitment to electrical safety, quality workmanship, and compliance with the latest industry standards — giving you complete peace of mind on every job.
            </p>
            <div className="mt-5 flex flex-wrap gap-3 justify-center md:justify-start">
              {[
                { icon: 'ri-shield-check-fill', label: 'BS7671 Compliant' },
                { icon: 'ri-medal-fill', label: 'NICEIC Certified' },
                { icon: 'ri-verified-badge-fill', label: '10+ Years Approved' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-1.5 bg-[#FFD700]/10 border border-[#FFD700]/30 rounded-full px-3 py-1.5">
                  <i className={`${item.icon} text-[#FFD700] text-sm`}></i>
                  <span className="text-white text-xs font-medium whitespace-nowrap">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Domestic and Commercial */}
        <div className="mt-16 sm:mt-20">
          <h3 className="text-2xl sm:text-3xl font-bold text-white text-center mb-8 sm:mb-12">
            Our <span className="text-[#FFD700]">Domestic &amp; Commercial</span> Experience
          </h3>
          <div className="grid md:grid-cols-2 gap-6 sm:gap-8">
            <div className="bg-white/5 backdrop-blur-sm rounded-lg p-5 sm:p-8 border border-[#FFD700]/20 hover:border-[#FFD700] transition-all duration-300">
              <img
                src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/f7c9d4e49fa7a28c913f25889ad03751.png"
                alt="Domestic Electrician"
                className="w-full h-48 sm:h-64 object-cover rounded-lg mb-5"
              />
              <h4 className="text-xl sm:text-2xl font-bold text-[#FFD700] mb-3">Domestic Services</h4>
              <p className="text-gray-300 text-sm leading-relaxed">
                Our services extend to residential clients with over a decade of electrical experience. Beyond Electrical ensures client satisfaction with professional domestic electrical work.
              </p>
            </div>
            <div className="bg-white/5 backdrop-blur-sm rounded-lg p-5 sm:p-8 border border-[#FFD700]/20 hover:border-[#FFD700] transition-all duration-300">
              <img
                src="https://static.readdy.ai/image/4a891bf01ca77aa59d4e684a3f5f885b/a36f7c852c7b6d0c1b2ac3e857ac4cf3.png"
                alt="Commercial Electrician"
                className="w-full h-48 sm:h-64 object-cover rounded-lg mb-5"
              />
              <h4 className="text-xl sm:text-2xl font-bold text-[#FFD700] mb-3">Commercial Services</h4>
              <p className="text-gray-300 text-sm leading-relaxed">
                We provide comprehensive commercial electrical services. At Beyond Electrical we pride ourselves on delivering fantastic service beyond expectation for all business clients.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
